import React from 'react';

/**
 * PrintHeader — shows the Atlas History wordmark + context line ONLY on print.
 * Hidden on screen; block-level in print via Tailwind `print:block`.
 *
 * Usage:
 *   <PrintHeader
 *     resourceType="Skeleton Notes"
 *     resourceTitle={selectedNote?.title}
 *     grade={unit?.grade_level}
 *     unitNumber={unit?.unit_number}
 *     unitTitle={unit?.title}
 *   />
 */
export function PrintHeader({ resourceType, resourceTitle, grade, unitNumber, unitTitle }) {
  const contextLine = [
    grade && `Grade ${grade}`,
    unitNumber != null && `Unit ${unitNumber}`,
    unitTitle,
  ].filter(Boolean).join(' • ');

  return (
    <div
      className="hidden print:block mb-4 pb-3 border-b border-black"
      data-testid="print-header"
    >
      <div className="flex items-baseline justify-between">
        <span className="text-[9pt] uppercase tracking-[0.28em] text-black font-semibold">
          Atlas History
        </span>
        {resourceType && (
          <span className="text-[9pt] uppercase tracking-wide text-black">
            {resourceType}
          </span>
        )}
      </div>
      {(contextLine || resourceTitle) && (
        <div className="mt-1 text-[10pt] text-black">
          {resourceTitle && <span className="font-semibold">{resourceTitle}</span>}
          {resourceTitle && contextLine && <span> — </span>}
          {contextLine && <span>{contextLine}</span>}
        </div>
      )}
    </div>
  );
}

export default PrintHeader;
